import layout from '@/views/common/layout'
const externalRouter = [
    {
        path: '/external',
        component: layout,
        children: [
            {
                path: 'exBrandList',
                component: () => import('@/views/external/exBrandList'),
                name: 'exBrandList',
                meta: { title: '外部品牌列表', icon: '', affix: true }
            },
            {
                path: 'exCategoryList',
                component: () => import('@/views/external/exCategoryList'),
                name: 'exBrandList',
                meta: { title: '外部产品系列列表', icon: '', affix: true }
            }, 
            {
                path: 'exGoodsList',
                component: () => import('@/views/external/exGoodsList'),
                name: 'exGoodsList',
                meta: { title: '外部产品列表', icon: '', affix: true }
            },
            {
                path: 'exCompareList',
                component: () => import('@/views/external/exCompareGoodsList'),
                name: 'exCompareList',
                meta: { title: '外部产品交叉对比及适配管理列表', icon: '', affix: true }
            },
            {
                path: 'exSheetList',
                component: () => import('@/views/external/exGoodsSheetList'),
                name: 'exSheetList',
                meta: { title: '询价管理列表', icon: '', affix: true }
            },
            {
                path: 'editGoodsSheet',
                component: () => import('@/views/external/editGoodsSheet'),
                name: 'editGoodsSheet',
                meta: { title: '询价详情', icon: '', affix: true }
            }
        ]
    },
]

export default externalRouter


// WEBPACK FOOTER //
// ./src/router/modules/externalRouter.js